

import { Component, Mixins, Prop, Watch, Emit } from 'vue-property-decorator';
import IBDialogContainerProps from "@/components/IBDialog/mixins/IBDialogContainerProps";
import { Properties } from 'csstype';

@Component
export default class IBDialogContainer extends Mixins(IBDialogContainerProps) {

	$refs!: {
		dialog: HTMLElement
	}

	@Prop({ type: Boolean, default: false })
	readonly value!: boolean

	@Prop({ type: Boolean, default: false })
	readonly transparent!: boolean

	@Prop({ type: Boolean, default: false })
	readonly overflowVisible!: boolean

	@Prop({ type: Boolean, default: false })
	readonly actionSheet!: boolean

	@Prop({ type: [ Number, String ], default: 526 })
	readonly width!: string | number

	@Prop(String)
	readonly containerClassName!: string

	dialogActiveClass: string = 'dialog--active'

	cantClose: boolean = false

	persistentAnimTime: number = 70

	isCloseDialogOnTouchEnd: boolean = false

	touchInitialYCoordinate: number = 0

	isPreActive: boolean = false

	isActive: boolean = false

	isRendered: boolean = false

	touchEndHandler = () => this.closeDialogOnTouchEnd()

	touchMoveHandler = (e: TouchEvent) => this.checkIsCloseDialogOnTouchEnd(e.changedTouches[0].pageY)

	touchStartHandler = (e: TouchEvent) => this.setInitialTouchCoordinate(e.changedTouches[0].pageY)

	touchHandlers = {
		touchmove: this.touchMoveHandler,
		touchend: this.touchEndHandler,
		touchcancel: this.touchEndHandler,
		touchstart: this.touchStartHandler
	}

	created() {
		this.setDialogActiveState();
	}

	mounted() {
		this.addTouchHandlers();
	}

	beforeDestroy() {
		this.removeTouchHandlers();
	}

	setDialogTouchHandlersByMethod(method: keyof HTMLElement) {
		if (!this.$refs.dialog) return;

		for (let i in this.touchHandlers) (<any>this).$refs.dialog[method](i, (<any>this).touchHandlers[i]);
	}

	addTouchHandlers() {
		this.setDialogTouchHandlersByMethod('addEventListener');
	}

	removeTouchHandlers() {
		this.setDialogTouchHandlersByMethod('removeEventListener');
	}

	setInitialTouchCoordinate(y: number) {
		this.touchInitialYCoordinate = y;
	}

	checkIsCloseDialogOnTouchEnd(y: number) {
		this.isCloseDialogOnTouchEnd = this.$refs.dialog.scrollTop
			? false
			: y > this.touchInitialYCoordinate;
	}

	closeDialogOnTouchEnd() {
		!this.persistent && this.isCloseDialogOnTouchEnd && this.closeDialog();
	}

	setDialogActiveState() {
		if (this.value) this.isRendered = this.value;

		setTimeout(() => {
			this.isActive = this.value;

			this.preActive();

			document.body.classList[this.value ? 'add' : 'remove'](this.dialogActiveClass);

			if (!this.value) setTimeout(() => this.isRendered = false, this.animationTime);
		});
	}

	preActive() {
		this.isPreActive = true;

		setTimeout(() => this.isPreActive = false, this.animationTime);
	}

	closeDialogGivenPersistent() {
		if (!this.persistent) {
			this.closeDialog();
		} else {
			this.cantClose = true;

			setTimeout(() => this.cantClose = false, this.persistentAnimTime);
		}
	}

	get getBorderRadius(): string {
		return this.$attrs.borderRadius === '24' ? '24px' : '12px';
	}

	get realWidth(): string {
		return (typeof this.width === 'string' && !/^[0-9]+$/.test(String(this.width)))
			? this.width
			: this.width + 'px';
	}

	get transitionStyle(): Properties {
		return typeof this.animationTime === 'number'
			? { transitionDuration: `${this.animationTime}ms` }
			: {};
	}

	get transitionContentStyle(): Properties {
		return typeof this.animationTime === 'number'
			? { transitionDuration: `${this.animationTime + 100}ms` }
			: {};
	}

	@Watch('value')
	isActiveUpdated() {
		this.setDialogActiveState();
	}

	@Emit('input')
	closeDialog() {
		this.preActive();

		return false;
	}

}

